import $ from "jquery";

/*------------------------------------*\
    FEEDBACK PROGRESS
\*------------------------------------*/
var feedback = require('../../site/_data/site');

class FeedbackProgress {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        //self.getCompletedSections();
        self.checkSectionComplete();
    }

    checkSectionComplete() {
        // Loop through feedback sections and check against section keys in local storage by index
        feedback.consultation.themes.forEach((section, index) => {          
            if(JSON.parse(localStorage.getItem('0' + (index + 1) + '-section'))) {
                // Show 'section complete' message
                $("#section" + (index + 1)).removeClass("d-none");

                // Change button
                // a. Update to pencil icon
                $("#add-icon--section-" + (index + 1)).addClass("d-none");
                $("#edit-icon--section-" + (index + 1)).removeClass("d-none");

                // b. Update text
                $("#feedback-button--section-" + (index + 1)).text("Change");

                // c. Show completed icon in feedback nav
                $("#section-" + (index + 1) + "-complete").text("Complete");
            }
        })  

        // Check if user details have been completed
        if(JSON.parse(localStorage.getItem('your-details-section'))) {
            // Show completed icon in feedback nav
            $("#your-details-complete").text("Complete");
        }
    }
    
    getCompletedSections() {

        let completed = [],
            feedbackProgress = document.getElementById('feedback-progress'),    
            progress = document.getElementById('progress-indicator'),
            review = document.getElementById('review-btn'),
            counts = {};

        // Count how many local storage values match sections
        feedback.consultation.themes.forEach((section) => {         
            let answered = JSON.parse(localStorage.getItem(section.key));

            // Push to completed array ready to count
            if(answered) {
                completed.push(answered);
            }
        })

        // Count how many items in completed
        for (const num of completed) {
            counts[num] = counts[num] ? counts[num] + 1 : 1;
        }

        // Don't show progress panel on feedback form pages
        let url = window.location.href;
        
        if(!url.includes(["feedback-form"])) {
            // Only show progress if at least one answer
            if(counts[true]) {
                feedbackProgress.classList.add('d-flex');
                review.classList.add('d-block');
                document.body.classList.add('feedback-padding');
            }
        }

        // Print out
        progress.innerHTML = (completed.length ? counts[true] : 0) + '/' + feedback.consultation.themes.length + ' sections completed';
    }
}

export default FeedbackProgress;